<form [formGroup]="ondernemingFG">
    <div formArrayName="ondernemingen">
        <div *ngFor="let onderneming of ondernemingen.controls; let i = index" [formGroupName]="i"
             class="row mb-1">
            <div class="row mb-1">
                <div class="col-auto">
                    <snelstart-ui-text-form-control (change)="this.saveForm()"
                                                    class="custom-input-250"
                                                    formControlName="naam"
                                                    id="naam"
                                                    label="Naam"
                    >
                    </snelstart-ui-text-form-control>
                </div>
                <div class="col-auto">
                    <snelstart-ui-button (click)="showInfoVerwijderen()"
                                         [class]="i === 0 ? 'firstrowbutton' : ''"
                                         icon="trash"
                                         iconType="light"
                                         id="buttonDeleteKosten"
                                         size="medium"
                                         type="secondary"
                    >
                    </snelstart-ui-button>
                </div>
            </div>
            <div>
                <snelstart-ui-textarea-form-control
                        (change)="saveForm()"
                        [rows]=2
                        class="custom-input-250"
                        formControlName="werkzaamheden"
                        id="werkzaamheden"
                        label="Werkzaamheden"
                        maxlength="70"
                >
                </snelstart-ui-textarea-form-control>
            </div>
            <div>
                <snelstart-ui-select-form-control (change)="saveForm()"
                                                  [options]="ondernemingsvorm"
                                                  class="custom-input-250"
                                                  formControlName="ondernemingsvorm"
                                                  label="Ondernemingsvorm"
                >
                </snelstart-ui-select-form-control>
            </div>
            <ng-container *ngIf="ondernemingen.controls[i].get('ondernemingsvorm')?.value === 'VOF' ||
                            ondernemingen.controls[i].get('ondernemingsvorm')?.value === 'MAATSCHAP'">
                <div>
                    <snelstart-ui-bsn-form-control (change)="saveForm()"
                                                   class="custom-input-250"
                                                   formControlName="rsin"
                                                   id="rsin"
                                                   label="RSIN onderneming"
                    >
                    </snelstart-ui-bsn-form-control>
                </div>
            </ng-container>
            <ng-container *ngIf="ondernemingen.controls[i].get('ondernemingsvorm')?.value === 'VOF' ||
                            ondernemingen.controls[i].get('ondernemingsvorm')?.value === 'MAATSCHAP'">
                <div>
                    <snelstart-ui-select-form-control
                            (change)="saveForm()"
                            [options]="optionsJaNee"
                            class="custom-input-250"
                            formControlName="invullenOpNiveauSamenwerkingsverband"
                            id="invullenOpNiveauSamenwerkingsverband-{{i}}"
                            label="Invullen cijfers op samenwerkingsniveau"
                    >
                    </snelstart-ui-select-form-control>
                </div>
            </ng-container>
            <ng-container *ngIf="(ondernemingen.controls[i].get('ondernemingsvorm')?.value === 'VOF' ||
                            ondernemingen.controls[i].get('ondernemingsvorm')?.value === 'MAATSCHAP') &&
                            ondernemingen.controls[i].get('invullenOpNiveauSamenwerkingsverband')?.value === false
                ">
                <div>
                    <snelstart-ui-select-form-control
                            (change)="saveForm()"
                            [options]="optionsJa"
                            class="custom-input-250"
                            formControlName="invullenOpPersoonlijkNiveau"
                            id="invullenOpPersoonlijkNiveau-{{i}}"
                            label="Invullen cijfers op persoonlijk niveau"
                    >
                    </snelstart-ui-select-form-control>
                </div>
            </ng-container>
<!--            <ng-container class="row" formGroupName="boekjaar">-->
<!--                <div>-->
<!--                    <snelstart-ui-date-form-control (change)="saveForm()"-->
<!--                                                    class="custom-input-250"-->
<!--                                                    formControlName="begindatum"-->
<!--                                                    id="begindatum"-->
<!--                                                    label="Begin boekjaar"-->
<!--                    >-->
<!--                    </snelstart-ui-date-form-control>-->
<!--                </div>-->
<!--                <div>-->
<!--                    <snelstart-ui-date-form-control (change)="saveForm()"-->
<!--                                                    class="custom-input-250"-->
<!--                                                    formControlName="einddatum"-->
<!--                                                    id="einddatum"-->
<!--                                                    label="Einde boekjaar"-->
<!--                    >-->
<!--                    </snelstart-ui-date-form-control>-->
<!--                </div>-->
<!--            </ng-container>-->
        </div>
        <div *ngIf="ondernemingen.length === 0">
            <snelstart-ui-button (click)="addOnderneming()" class="snelstart-ui-button pb-3" icon="plus"
                                 type="link">Gegevens onderneming invullen
            </snelstart-ui-button>
        </div>
    </div>
</form>

<snelstart-ui-dialog-definition [(visible)]="openInfoVerwijderen"
                                id="specinkBox1" size="md"
                                title="Verwijderen gegevens onderneming">
    <snelstart-ui-dialog-body>
        <div class="d-flex pt-2 ps-1 pb-2">
            Weet je zeker dat je de gegevens {{ this.incomeTaxEntity.aangifte?.aangifteJaar }} van de
            onderneming definitief uit deze aangifte wilt verwijderen?
        </div>
    </snelstart-ui-dialog-body>
    <snelstart-ui-dialog-buttons class="d-flex mt-2">
        <snelstart-ui-button btn-x icon="xmark" id="saveinkBox2" type="secondary">Nee; annuleren
        </snelstart-ui-button>
        <snelstart-ui-button (click)="verwijderOnderneming(0)" class="ps-3" icon="check" id="saveinkBox1"
                             type="danger">
            Ja; verwijderen
        </snelstart-ui-button>
    </snelstart-ui-dialog-buttons>
</snelstart-ui-dialog-definition>

